import { keepPreviousData, useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { appliesQueryKeys } from "./query-keys";

import { instance } from "@/lib/axios/instance";

export type AppliesMetricsResponse = {
  count: number;
  distinctIntegrations: number;
  distinctClients: number;
};

export type UseAppliesMetricsParams = {
  clients?: string[];
  integrations?: string[];
  applicationSourceTypes?: string[];
  matchIds?: string[];
  candidateIds?: string[];
  publicationIds?: string[];
  search?: string;
  tenantId?: string | null;
  startDate?: string | null;
  endDate?: string | null;
};

export function useAppliesMetrics(
  params: UseAppliesMetricsParams
): UseQueryResult<AppliesMetricsResponse, AxiosError> {
  return useQuery({
    queryKey: appliesQueryKeys.metrics(params),
    queryFn: () =>
      instance
        .get<AppliesMetricsResponse>("/api/v2/Applies/Metrics/Aggregated", { params })
        .then((res) => res.data),
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
